import { call } from '../core';

export const callGetDashboard = () => call('dashboard', 'GET', {});
